module.exports = __webpack_public_path__ + "static/media/Click2CartLogo_2Color_Horz.f9eff65c.png";